import api from "./api";
import TokenService from "./token.service";

class AuthService {
  login(username, password) {
    return api
      .post("/auth/signin", {
        email: username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
  }

  me() {
    return api
      .post("/auth/me")
      .then(response => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }
        return response.data;
      });
  }

  logout() {
    return api
      .post("/auth/logout")
      .then(response => {
        if (response.data.accessToken) {
          TokenService.removeUser();
        }
        return response.data;
      });
  }


  /*
  logout() {
    TokenService.removeUser();
  }
  */

  register(username, email, password) {
    return api.post("/auth/signup", {
      username,
      email,
      password
    });
  }
}

export default new AuthService();
